import React from "react";
import { Field, Form, Formik, FormikConfig } from "formik";
import { object, string } from "yup";

import { useEditEntityMutation } from "@mutations/entity";
import { useEntity } from "@components/entity/useEntity";
import {
    PlainModal,
    StandardModalHeader,
} from "@components/general/Modal/Modal";
import { useToaster } from "@components/general/ToastMessages/useToaster";
import { FormRow } from "@components/forms/FormRow";
import { submitHelper } from "@helpers/form";
import { EditModalFooter } from "./EditModalFooter";

interface Props {
    show: boolean;
    onClose(): void;
}

export const UpdateWebsiteModal: React.FC<Props> = ({ show, onClose }) => {
    const entity = useEntity();
    const editEntity = useEditEntityMutation(entity);

    const { error } = useToaster();

    const form: FormikConfig<{ website: string }> = {
        initialValues: {
            website: entity.profile?.website ?? "",
        },
        validationSchema: object().shape({
            website: string().url("Invalid URL"),
        }),
        onSubmit: submitHelper({
            handler: async ({ website }) => {
                try {
                    await editEntity.mutateAsync({
                        profile: { ...entity.profile, website },
                    });
                    onClose();
                } catch {
                    error("Failed to update profile");
                }
            },
        }),
    };

    return (
        <PlainModal show={show} onHide={onClose}>
            <StandardModalHeader>
                <h4 className="m-0">Update Website</h4>
            </StandardModalHeader>
            <Formik {...form}>
                {({ isValid, isSubmitting }) => (
                    <Form>
                        <FormRow
                            showErrorMessage={false}
                            fieldName="website"
                            label="Website"
                        >
                            <Field name="website" className="form-control" />
                        </FormRow>
                        <EditModalFooter
                            onClose={onClose}
                            isValid={isValid}
                            isSubmitting={isSubmitting}
                        />
                    </Form>
                )}
            </Formik>
        </PlainModal>
    );
};
